import Api from "@services/api";

export const getFismaAttrs = async () => {
  const res = await Api().get("/fisma-page?populate=deep");

  return res.data;
};

export const getFips1402Attrs = async () => {
  const res = await Api().get("/fips1402?populate=deep");

  return res.data;
};

export const getFips1403Attrs = async () => {
  const res = await Api().get("/fips1403?populate=deep");

  return res.data;
};
